import { useClients } from '@/api/clients';
import { Text } from '@/components/Text';
import Block from '@shared/components/ui/Block';

/**
 * Spike screen: proves the browser-held Auth0 token is accepted by the backend
 * over CORS via a real authenticated GET /clients. Intentionally minimal — the
 * full clients UI is ported in a later phase.
 */
export function ClientsPage() {
    const { data: clients, isLoading, error } = useClients();

    return (
        <Block style={{ padding: 40 }}>
            <Text as="h1" size="xLarge" weight="bold" color="uNavy" spacing="medium">
                Clients
            </Text>

            {isLoading && <Text color="uNavy">Loading…</Text>}

            {error && (
                <Text color="red">
                    Failed to load clients: {(error as Error).message}
                </Text>
            )}

            {clients && clients.length === 0 && (
                <Text color="uNavy">No clients yet.</Text>
            )}

            {clients?.map((client) => (
                <Block key={client.clientId} spacing="xxSmall">
                    <Text color="uNavy">
                        {client.name ?? client.clientReference}
                    </Text>
                </Block>
            ))}
        </Block>
    );
}
